
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/searchResultPage/SearchResultPage",
      function () {
        return require("private-next-pages/searchResultPage/SearchResultPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/searchResultPage/SearchResultPage"])
      });
    }
  